import React, { useEffect, useState, useCallback } from "react";
import { Table, Tag, Typography, Button, Drawer, Divider, message } from "antd";
import { getRequest } from "../../../helpers/apiCall";
import { EyeOutlined } from "@ant-design/icons";
import { AssignQuestionToExpertModal } from "../../common/modal/assignToModal";


const { Title, Text, Paragraph } = Typography;

const HelpRecommendExperts = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [showAssignModal, setShowAssignModal] = useState(false);
  const getNeedHelpQuestionsResult = useCallback(async () => {
    setLoading(true);
    try {
      const resp = await getRequest("need-help-questions");
      if (resp?.data?.success) {
        setData(resp.data.data || []);
      } else {
        message.error("Failed to fetch data");
      }
    } catch (error) {
      message.error(error.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    getNeedHelpQuestionsResult();
  }, [getNeedHelpQuestionsResult]);

  const columns = [
    {
      title: "Request ID",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "Description",
      dataIndex: "question_disc",
      key: "question_disc",
      ellipsis: true,
    },
    {
      title: "Created At",
      dataIndex: "created_at",
      key: "created_at",
      render: (val) => new Date(val).toLocaleString(),
    },
    {
      title: "Expert Approved",
      dataIndex: "expert_approved",
      key: "expert_approved",
      render: (approved) => (
        <Tag color={approved ? "green" : "red"}>{approved ? "Yes" : "No"}</Tag>
      ),
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Button
          type="link"
          icon={<EyeOutlined />}
          onClick={() => {
            setSelectedItem(record);
            setDrawerOpen(true);
          }}
        >
          View More
        </Button>
      ),
    },
  ];

  return (
    <div style={{ padding: 20 }}>
      <Title level={3}>Help Recommended Experts</Title>
      <Divider />

      <Table
        columns={columns}
        dataSource={data}
        rowKey="id"
        loading={loading}
        pagination={{ pageSize: 5 }}
      />

      {/* Drawer for detailed view */}
      <Drawer
        title={`Request Details - ${selectedItem?.id}`}
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        width={600}
      >
        {selectedItem && (
          <div>
            <Paragraph>
              <Text strong>Description: </Text> {selectedItem.question_disc}
            </Paragraph>

            <Paragraph>
              <Text strong>Created At: </Text>{" "}
              {new Date(selectedItem.created_at).toLocaleString()}
            </Paragraph>

            <Paragraph>
              <Text strong>Expert Approved: </Text>{" "}
              <Tag color={selectedItem.expert_approved ? "green" : "red"}>
                {selectedItem.expert_approved ? "Yes" : "No"}
              </Tag>
            </Paragraph>

            <Paragraph>
              <Text strong>Assigned by Admin: </Text>{" "}
              <Tag color={selectedItem.assign_by_admin ? "blue" : "orange"}>
                {selectedItem.assign_by_admin ? "Yes" : "No"}
              </Tag>
            </Paragraph>

            <Paragraph>
              <Text strong>Matching Automation: </Text>{" "}
              <Tag
                color={selectedItem.matching_automation ? "purple" : "default"}
              >
                {selectedItem.matching_automation ? "Enabled" : "Disabled"}
              </Tag>
            </Paragraph>

            {selectedItem.expert_report && (
              <>
                <Divider />
                <Text strong>Expert Report:</Text>
                <Paragraph style={{ whiteSpace: "pre-line" }}>
                  {selectedItem.expert_report}
                </Paragraph>
              </>
            )}

            <Divider />
            <Button
              type="primary"
              onClick={() => {
                setShowAssignModal(true);
              }}
            >
              Assign Expert
            </Button>
          </div>
        )}
      </Drawer>
      {showAssignModal && (
              <AssignQuestionToExpertModal
                visible={showAssignModal}
                setVisible={setShowAssignModal}
                // rowData={currentRecord}
                // rawData={rawData}
                // doRefresh={() => doRefresh()}
                variant="admin"
              />
            )}
    </div>
  );
};

export default HelpRecommendExperts;
